import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import type { ClientOutlook } from '../store/insights'
import { InsightsSection, InfoTooltip } from './insightsCommon'

const CLIENT_OUTLOOK_VISIBLE = 5

export const ClientOutlookSection: React.FC<{ data: ClientOutlook }> = ({ data }) => {
  const [expanded, setExpanded] = useState(false)
  const visibleOptimistic = expanded ? data.optimisticRows : data.optimisticRows.slice(0, CLIENT_OUTLOOK_VISIBLE)
  const visibleConcerned = expanded ? data.concernedRows : data.concernedRows.slice(0, CLIENT_OUTLOOK_VISIBLE)
  const hasMore = data.totalAssetClasses > CLIENT_OUTLOOK_VISIBLE

  return (
    <InsightsSection title='Client outlook' subtitle='Clients expressed sentiment about specific asset classes'>
      <div className='px-4'>
        <Row>
          <Col md={6}>
            <div className='insights-outlook-column-label insights-label-with-tooltip'>
              OPTIMISTIC <InfoTooltip text='Asset classes that clients felt optimistic about' />
            </div>
            {visibleOptimistic.map((row) => (
              <div key={row.assetClass} className='insights-outlook-row'>
                <span className='insights-outlook-row__label'>{row.assetClass}</span>
                <div className='insights-outlook-row__bar'>
                  <div className='insights-outlook-row__bar-fill--optimistic' style={{ width: `${row.optimisticBarWidth}%` }} />
                </div>
                <span className='insights-outlook-row__value'>{row.optimisticPercent}</span>
              </div>
            ))}
          </Col>
          <Col md={6}>
            <div className='insights-outlook-column-label insights-label-with-tooltip'>
              CAUTIOUS <InfoTooltip text='Asset classes that clients felt cautious about' />
            </div>
            {visibleConcerned.map((row) => (
              <div key={row.assetClass} className='insights-outlook-row'>
                <span className='insights-outlook-row__label'>{row.assetClass}</span>
                <div className='insights-outlook-row__bar'>
                  <div className='insights-outlook-row__bar-fill--concerned' style={{ width: `${row.concernedBarWidth}%` }} />
                </div>
                <span className='insights-outlook-row__value'>{row.concernedPercent}</span>
              </div>
            ))}
          </Col>
        </Row>

        {hasMore && (
          <div className='text-center mt-3'>
            <button type='button' className='btn btn-link p-0 insights-link border-0 bg-transparent' onClick={() => setExpanded((prev) => !prev)}>
              {expanded ? 'Show less' : `Show all asset classes \u2193`}
            </button>
          </div>
        )}
      </div>
    </InsightsSection>
  )
}
